import styled from "styled-components"

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ theme }) => theme.space[3]};

  @media ${({ theme }) => theme.media.lg_down} {
    grid-template-columns: 1fr;
  }
`
